<div class="main-content table-page table-page--compact oportunidades-page" [class]="'oportunidades-page--' + vista.variante">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>{{ vista.titulo }}</h1>
        <p>{{ vista.descripcion }}</p>
      </div>

      <button *ngIf="vista.conAlta" type="button" mat-raised-button class="btn table-page__primary-btn" (click)="openAddProyecto()">
        <i class="material-icons">add</i>
        <span>Alta de Oportunidad</span>
      </button>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar table-page__toolbar--filters">
        <div class="table-page__filters-grid">
          <div class="table-page__filter table-page__filter--wide">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Buscar oportunidad</mat-label>
              <input aria-label="Buscar oportunidad" matInput maxlength="200" autocomplete="off" [ngModel]="nomProyecto" (ngModelChange)="onProyectoChange($event)" />
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Cliente</mat-label>
              <mat-select [ngModel]="nomCliente" (ngModelChange)="onClienteChange($event)">
                <mat-option>
                  <ngx-mat-select-search [formControl]="formCliente" [placeholderLabel]="'Buscar'" [noEntriesFoundLabel]="'No existe cliente'">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option [value]="''">Todos</mat-option>
                <mat-option *ngFor="let item of listaClientes" [value]="item.razonsocial">
                  {{ item.razonsocial }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="table-page__filter table-page__filter--medium" *ngIf="vista.conFiltroEstatus">
            <mat-form-field appearance="outline" class="table-page__field">
              <mat-label>Estado</mat-label>
              <mat-select [ngModel]="estatusOportunidad" (ngModelChange)="onEstatusChange($event)">
                <mat-option [value]="''">Todos</mat-option>
                <mat-option *ngFor="let item of listaEstatus" [value]="item.name">
                  {{ item.val }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="table-page__toolbar-actions">
          <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="clearFilters()">
            <i class="material-icons">close</i>
            <span>Limpiar</span>
          </button>
        </div>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="oportunidades.length > 0; else oportunidadesMarketingEmptyState">
          <thead>
            <tr>
              <th>Oportunidad</th>
              <th>Estado</th>
              <th>Grupo</th>
              <th>Cliente</th>
              <th>Inicio</th>
              <th>Estimación</th>
              <th>Semáforo</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let proyecto of oportunidades">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ proyecto.nombre || 'Sin nombre' }}</strong>
                  <span class="table-page__subtext">ID {{ proyecto.idProyecto || proyecto.id || '-' }}</span>
                </div>
              </td>
              <td><span class="table-page__text">{{ proyecto.estatus || '-' }}</span></td>
              <td><span class="table-page__text">{{ proyecto.grupo || '-' }}</span></td>
              <td><span class="table-page__text">{{ proyecto.nombreCliente || '-' }}</span></td>
              <td><span class="table-page__text">{{ proyecto.fechaCreacion | date: 'dd/MM/yyyy' }}</span></td>
              <td><span class="table-page__text">{{ proyecto.fechaEstimacion | date: 'dd/MM/yyyy' }}</span></td>
              <td>
                <span class="table-page__status-badge" [ngClass]="getHealthClass(proyecto)">
                  {{ getHealthLabel(proyecto) }}
                </span>
              </td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn" title="Ver seguimiento" aria-label="Ver seguimiento" (click)="mostrarSeguimiento(proyecto)">
                  <i class="material-icons">view_timeline</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #oportunidadesMarketingEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else oportunidadesMarketingLoadingState">
            <i class="material-icons">work_history</i>
            <strong>No se encontraron oportunidades</strong>
            <span>{{ vista.textoSinResultados }}</span>
          </div>
        </ng-template>

        <ng-template #oportunidadesMarketingLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando oportunidades...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} oportunidades</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">Inicio</button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">Anterior</button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button *ngIf="isPageNumber(item); else oportunidadesMarketingPagerEllipsis" type="button" class="table-page__pager-page"
              [class.is-current]="item === currentPage" (click)="onPageChange(item)">
              {{ item }}
            </button>

            <ng-template #oportunidadesMarketingPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage === totalPages">Siguiente</button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage === totalPages">Último</button>
        </div>
      </div>
    </section>
  </div>
</div>
